import styled from 'styled-components';
import { NewInput } from '../NewInput';

export const Datepicker = styled(NewInput)`
  background-color: #f3f7f9;
  border: solid 1px #cbd6e2;
  border-radius: 5px;
`